// Magnetic Field Strength units with conversion factors to ampere/meter (A/m)
export const magneticFieldStrengthUnits = [
  { id: 'ampere-per-meter', name: 'Ampere/Meter', symbol: 'A/m', plural: 'Amperes/Meter', factor: 1 },
  { id: 'ampere-turn-per-meter', name: 'Ampere-turn/Meter', symbol: 'At/m', plural: 'Ampere-turns/Meter', factor: 1 },
  { id: 'kiloampere-per-meter', name: 'Kiloampere/Meter', symbol: 'kA/m', plural: 'Kiloamperes/Meter', factor: 1e3 },
  { id: 'oersted', name: 'Oersted', symbol: 'Oe', plural: 'Oersteds', factor: 79.5774715 },
  { id: 'gilbert-per-meter', name: 'Gilbert/Meter', symbol: 'Gi/m', plural: 'Gilberts/Meter', factor: 79.5774715 },
  { id: 'ampere-per-centimeter', name: 'Ampere/Centimeter', symbol: 'A/cm', plural: 'Amperes/Centimeter', factor: 100 },
  { id: 'ampere-per-inch', name: 'Ampere/Inch', symbol: 'A/in', plural: 'Amperes/Inch', factor: 39.3700787 },
];

export const popularMagneticFieldStrengthConversions = [
  { from: 'ampere-per-meter', to: 'oersted' },
  { from: 'oersted', to: 'ampere-per-meter' },
  { from: 'ampere-per-meter', to: 'kiloampere-per-meter' },
  { from: 'oersted', to: 'gilbert-per-meter' },
  { from: 'ampere-per-meter', to: 'ampere-per-centimeter' },
];

export const getUnitById = (id) => magneticFieldStrengthUnits.find(unit => unit.id === id);

export const convertMagneticFieldStrength = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert magnetic field strength units and learn the conversion formula.`;
};
